export const fmtMoney = (n: number | string | null | undefined, frac = 2) => {
  const v = Number(n ?? 0);
  return v.toLocaleString("en-US", { style: "currency", currency: "USD", minimumFractionDigits: frac, maximumFractionDigits: frac });
};

export const fmtBTC = (n: number | string | null | undefined) => {
  const v = Number(n ?? 0);
  return `${v.toLocaleString("en-US", { minimumFractionDigits: 8, maximumFractionDigits: 8 })} BTC`;
};

export const fmtDate = (iso: string | Date) => {
  const d = typeof iso === "string" ? new Date(iso) : iso;
  return d.toLocaleString("en-US", { dateStyle: "medium", timeStyle: "short" });
};

export const shortAddr = (a?: string | null) =>
  !a ? "—" : a.length > 14 ? `${a.slice(0, 6)}…${a.slice(-6)}` : a;